<template>
 <!-- Main content -->
 <section class="content">
   <!-- Info boxes -->
   <div class="row">
     <div class="row">
        <div class="col-md-3 col-sm-6 col-xs-12" v-for="registro in  orderBy(registros, 'label')"  :key="registro.id" v-if="registro.exibir">
          <div class="info-box bg-yellow">
            <span class="info-box-icon"><i :class="registro.icone"></i></span>
            <div class="info-box-content">
              <span class="info-box-text" v-if="idioma === 'DE'">{{registro.labelDe}}</span>
              <span class="info-box-text" v-else-if="idioma === 'EN'">{{registro.labelEn}}</span>
              <span class="info-box-text" v-else-if="idioma === 'ES'">{{registro.labelEs}}</span>
              <span class="info-box-text" v-else>{{registro.labelPtBr}}</span>
              <span class="info-box-number" v-if="!registro.is_bool">{{registro.valor | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}<small> {{registro.unidade_medida}}</small></span>
              <span class="info-box-number" v-else-if="registro.valor">On</span>
              <span class="info-box-number" v-else>Off</span>
              <div class="progress">
                <div class="progress-bar" style="width: 100%"></div>
              </div>
              <span class="progress-description">
                {{registro.data_atualizacao}}
              </span>
           </div>
           <!-- /.info-box-content -->
         </div>  
       </div>
     </div>
     <!-- /.col -->
     <!-- fix for small devices only -->
     <div class="clearfix visible-sm-block"></div>
   </div>
   <!-- /.row -->
    <div class="row center-block" v-if="exibirGrafico">
      <div class="col-md-12">
        <div class="box">
          <div class="box-header" >
            <h4>{{tituloGrafico}}</h4>
            <va-chart
                :chart-config='seteDiasGrafico'></va-chart>
          </div>
        </div>
      </div>
      <!-- /.box-header -->
    </div>
   <!-- /.row -->

   <!-- Main row -->
   <div class="row">
   <!-- /.row -->
 </div>
 </section>
 <!-- /.content -->
</template>

<script>
import {firebaseApp} from '../../helpers/firebaseApp'
import Vue2Filters from 'vue2-filters'
import config from '../../config'
import VAChart from '../widgets/VAChart'

var db = firebaseApp.database()

export default {
  name: 'Dashboard',
  mixins: [Vue2Filters.mixin],
  components: {
    'va-chart': VAChart
  },
  mounted () {
    if (config.exibirGraficoInicial) {
      this.efetuarPesquisa()
    }
  },
  methods: {
    efetuarPesquisa: function () {
      this.pesquisa.parametro = config.grafico.parametro
      this.pesquisa.titulo = config.grafico.titulo
      this.pesquisa.label = config.grafico.label
      this.$store.dispatch('createGraficoSeteDias', this.pesquisa)
      .then(response => {
        this.seteDiasGrafico = response.data.grafico
        this.tituloGrafico = response.data.titulo
        this.exibirGrafico = true
      })
      .catch(e => {
        this.errors.push(e)
      })
    }
  },
  data () {
    return {
      registros: [],
      idioma: config.idioma,
      pesquisa: {
        titulo: '',
        parametro: '',
        label: ''
      },
      tituloGrafico: '',
      seteDiasGrafico: {},
      exibirGrafico: false
    }
  },
  firebase: {
    registros: db.ref(config.project)
  }
}
</script>
<style>
.info-box {
  cursor: pointer;
}
.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}
.fullCanvas {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?034c9d02